export function calculateExpiration(ttl) {
  let timeStamps = 0;

  if (typeof ttl === "number") {
    const now = new Date();
    timeStamps = new Date(now.getTime() + ttl * 1000);
  } else if (typeof ttl === "string") {
    const duration = parseInt(ttl, 10);
    const unit = ttl.slice(-1);

    if (isNaN(duration)) {
      throw new Error("Invalid TTL format");
    }

    const now = new Date();

    switch (unit) {
      case "s":
        timeStamps = new Date(now.getTime() + duration * 1000);
        break;
      case "m":
        timeStamps = new Date(now.getTime() + duration * 60000);
        break;
      case "h":
        timeStamps = new Date(now.getTime() + duration * 3600000);
        break;
      case "d":
        timeStamps = new Date(now.getTime() + duration * 86400000);
        break;
      default:
        throw new Error("Invalid TTL unit");
    }
  } else {
    throw new Error("Invalid TTL format");
  }

  return timeStamps.getTime();
}

export function persistCustomerAuth(userData) {
  const { user, expires_in } = userData;
  if (!user) return;

  const auth0Profile = {
    name: user.name,
    email: user.email,
  };

  localStorage.setItem("login1", JSON.stringify(true));
  localStorage.setItem("authenticated1", JSON.stringify(true));
  localStorage.setItem("expires_in1", calculateExpiration(expires_in));
  localStorage.setItem("auth1_profile", JSON.stringify(auth0Profile));
  localStorage.setItem("email", user.email);
  localStorage.setItem("Name1", JSON.stringify(user.name));
}
